module.exports = __webpack_public_path__ + "img/Spazi_scorrimento5.a83234b2.webp";